(function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "cre-t-4";

    /* all Pure helper functions */

    function waitForElement(selector, trigger, delayInterval = 50, delayTimeout = 15000) {
      var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    /**
     * Inserts HTML content or element after a target element
     * @param {string|HTMLElement} selector - CSS selector string or target element
     * @param {string|HTMLElement} html - HTML string to insert or DOM element
     */
    function insertAfter(selector, html) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      if (typeof html === "string") {
        element.insertAdjacentHTML("afterend", html);
      } else if (html && html.nodeType === 1) {
        element.insertAdjacentElement("afterend", html);
      }
    }

    function waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof window.Swiper != "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    function addScript() {
      if (document.querySelector("#cre-swiper-js")) return;
      var script = document.createElement("script");
      script.id = "cre-swiper-js";
      script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      document.querySelector("head").appendChild(script);

      var css = `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"/>`;
      document.querySelector("head").insertAdjacentHTML("beforeend", css);
    }

    var honeyRewardIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><script xmlns=""/>
        <g fill="none" fill-rule="evenodd">
            <path fill="#c75d00" d="M14 8.989a5.193 5.193 0 0 1-2.13 1.509c-1.148.435-2.504.435-4.058.024a.75.75 0 0 1 .383-1.45c1.274.336 2.317.336 3.142.023.471-.178.888-.442 1.255-.796h-2.167a3.007 3.007 0 0 1-3.007-3.006c0-1.677 1.13-3.043 2.688-3.043 1.359 0 2.683.899 3.554 2.252l1.335 1.969 1.334-1.969c.871-1.353 2.196-2.252 3.555-2.252 1.557 0 2.687 1.366 2.687 3.043a3.007 3.007 0 0 1-3.007 3.006h-2.216c.367.354.784.618 1.255.796.825.313 1.868.313 3.142-.024a.75.75 0 0 1 .383 1.45c-1.554.412-2.91.412-4.057-.023A5.182 5.182 0 0 1 16 9.058V25.55a.45.45 0 0 1-.45.45h-1.1a.45.45 0 0 1-.45-.45V8.989zm5.564-2.19c.833 0 1.507-.674 1.507-1.506 0-.905-.527-1.543-1.187-1.543-.786 0-1.675.603-2.303 1.579l-.997 1.47h2.98zm-6.158 0l-.997-1.47c-.628-.976-1.517-1.579-2.303-1.579-.66 0-1.188.638-1.188 1.543 0 .832.675 1.506 1.507 1.506h2.98z"/>
            <path fill="#4D4D4D" fill-rule="nonzero" d="M25.185 14.737l-.967 10.425a1.75 1.75 0 0 1-1.742 1.588H7.524a1.75 1.75 0 0 1-1.742-1.588l-.967-10.425C3.66 14.615 2.75 13.667 2.75 12.5v-2c0-1.25 1.045-2.25 2.318-2.25h.541a.75.75 0 0 1 0 1.5h-.54c-.46 0-.819.343-.819.75v2c0 .407.359.75.818.75h19.864c.459 0 .818-.343.818-.75v-2c0-.407-.359-.75-.818-.75h-.504a.75.75 0 0 1 0-1.5h.504c1.273 0 2.318 1 2.318 2.25v2c0 1.166-.91 2.115-2.065 2.237zm-18.862.013l.952 10.273a.25.25 0 0 0 .25.227h14.95a.25.25 0 0 0 .25-.227l.952-10.273H6.323z"/>
        </g>
    <script xmlns=""/>
    </svg>
    `;

    var translatedTextObject = {
      "en": {
        "Honey Rewards": "Honey Rewards",
        "usp1": {
          "title": "100% Raw, organic honey",
          "description": "Unpasteurised, coarse-filtered, straight from artisan beekeepers in wild landscapes.",
          "imageAlt": "SOIL ASSOCIATION ORGANIC Icon"
        },
        "usp2": {
          "title": "Tasted, tested, and traceable",
          "description": "Every new honey is vetted by our owner and lab-tested for purity.",
          "imageAlt": "Certified Icon"
        },
        "usp3": {
          "title": "Rare & Exciting Monoflorals",
          "description": "Oak, Sidr, Wild Lavender, Vanilla Fir, and Orange Blossom from remote mountains and forests.",
          "imageAlt": "Flower Icon"
        }
      },
      "de": {
        "Honey Rewards": "Honigprämien",
        "usp1": {
          "title": "100% roher Bio-Honig",
          "description": "Unpasteurisiert, grob gefiltert, direkt von handwerklich arbeitenden Imkern aus unberührten Naturlandschaften.",
          "imageAlt": "Soil Association Bio-Siegel"
        },
        "usp2": {
          "title": "Verkostet, geprüft und rückverfolgbar",
          "description": "Jede neue Honigsorte wird von unserem Inhaber begutachtet und im Labor auf Reinheit geprüft.",
          "imageAlt": "Zertifizierungs-Symbol"
        },
        "usp3": {
          "title": "Seltene & spannende Sortenhonige",
          "description": "Eiche, Sidr, wilder Lavendel, Vanille-Tanne und Orangenblüte aus abgelegenen Bergen und Wäldern.",
          "imageAlt": "Blumensymbol"
        }
      },
      "fr": {
        "Honey Rewards": "Récompenses Honey",
        "usp1": {
          "title": "Miel 100% brut et biologique",
          "description": "Non pasteurisé, filtré grossièrement, issu directement d'apiculteurs artisans travaillant dans des paysages sauvages.",
          "imageAlt": "Icône bio Soil Association"
        },
        "usp2": {
          "title": "Goûté, testé et traçable",
          "description": "Chaque nouveau miel est validé par notre propriétaire et soumis à des tests de pureté en laboratoire.",
          "imageAlt": "Icône de certification"
        },
        "usp3": {
          "title": "Miels monofloraux rares et exceptionnels",
          "description": "Chêne, Sidr, lavande sauvage, sapin vanillé et fleur d'oranger, issus de montagnes et de forêts reculées.",
          "imageAlt": "Icône de fleur"
        }
      }
    };

    var currentLanguage = "en";

    if (window.location.pathname == "/fr" || window.location.pathname.indexOf("/fr/") > -1) {
      currentLanguage = "fr";
    } else if (window.location.pathname == "/de" || window.location.pathname.indexOf("/de/") > -1) {
      currentLanguage = "de";
    }

    var translatedText = translatedTextObject[currentLanguage];

    var bannerHtml = `
      <div class="cre-t-4-container">
        <div class="cre-t-4-wrapper swiper">
          <div class="cre-t-4-swiper-wrapper swiper-wrapper">
            <div class="swiper-slide">
              <div class="cre-t-4-card cre-t-4-card1">
                <div class="cre-t-4-left">
                  <img src="https://cdn.shopify.com/s/files/1/0175/0288/files/Soil.svg?v=1784113637" alt="${translatedText.usp1.imageAlt}" />
                </div>
                <div class="cre-t-4-right">
                  <div class="cre-t-4-text1">${translatedText.usp1.title}</div>
                  <div class="cre-t-4-text2">${translatedText.usp1.description}</div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="cre-t-4-card cre-t-4-card2">
                <div class="cre-t-4-left">
                  <img src="https://cdn.shopify.com/s/files/1/0175/0288/files/qlementine_certified.svg?v=1784113598" alt="${translatedText.usp2.imageAlt}" />
                </div>
                <div class="cre-t-4-right">
                  <div class="cre-t-4-text1">${translatedText.usp2.title}</div>
                  <div class="cre-t-4-text2">${translatedText.usp2.description}</div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="cre-t-4-card cre-t-4-card3">
                <div class="cre-t-4-left">
                  <img src="https://cdn.shopify.com/s/files/1/0175/0288/files/streamline_flower_remix.svg?v=1784113653" alt="${translatedText.usp3.imageAlt}" />
                </div>
                <div class="cre-t-4-right">
                  <div class="cre-t-4-text1">${translatedText.usp3.title}</div>
                  <div class="cre-t-4-text2">${translatedText.usp3.description}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    var honeyRewardHtml = `
    <div class="cre-t-4-honey-reward">
      <a href="#smile-home">${translatedText["Honey Rewards"]}</a>
    </div>
    `;

    var honeyRewardMenuHtml = `
    <div class="cre-t-4-honey-reward-menu">
      <a href="#smile-home">${honeyRewardIcon}</a>
    </div>
    `;

    function insertHtml() {
      if (!document.querySelector(".cre-t-4-container")) {
        insertAfter("html body > .section-announcement", bannerHtml);
      }

      if (!document.querySelector(".cre-t-4-honey-reward")) {
        document.body.insertAdjacentHTML("beforeend", honeyRewardHtml);
      }

      if (!document.querySelector(".cre-t-4-honey-reward-menu")) {
        insertAfter(".header__top_left .menu-drawer-container", honeyRewardMenuHtml);
      }

      waitForSwiper(() => {
        var mySwiper = new Swiper(".cre-t-4-wrapper.swiper", {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          spaceBetween: 20,
          allowTouchMove: true,
          pagination: false,
          navigation: false,
          breakpoints: {
            1024: {
              slidesPerView: 3
            }
          }
          // effect: "fade",
          // fadeEffect: { crossFade: true },
        });
      });
    }

    /* Variation functions */

    /* Variation Init */
    function init() {
      if (debug) console.log(variation_name + " initialized");
      if (document.body.classList.contains(variation_name)) return;
      document.body.classList.add(variation_name);

      insertHtml();
    }

    // addScript();

    /* Initialise variation */
    waitForElement("html body > .section-announcement", init);
  } catch (e) {
    if (debug) console.log(e, "error in Test " + variation_name);
  }
})();
